<template>
  <div>
    <v-row v-if="images && images.length > 0">
      <v-col v-for="(img, index) in images" :key="index" cols="12">
        <v-card class="elevation-2 d-flex align-center pa-3 w-100">
          <v-avatar size="80" class="rounded-lg" color="grey lighten-4">
            <v-img :src="img.url" contain></v-img>
          </v-avatar>
          <v-spacer></v-spacer>
          <div class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="btn-edit rounded-pill mx-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="openCropper(index, img.url)"
                >
                  <v-icon>mdi-crop</v-icon>
                </v-btn>
              </template>
              <span>ویرایش عکس</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="btn-delete rounded-pill mx-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="removeImage(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>حذف عکس</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-alert v-else type="info" text>هنوز عکسی به لیست اضافه نشده است.</v-alert>

    <custom-popup
      v-model="cropperDialog"
      max-width="1024px"
      :cons="{ title: 'ویرایش و تنظیمات خروجی عکس', icon: 'mdi-pencil' }"
      @close="closeCropper"
    >
      <v-row v-if="cropperDialog">
        <v-col cols="12" md="8">
          <div class="mb-3 text-center">
            <v-btn
              class="mx-1 btn-download rounded-pill"
              icon
              small
              @click="rotateLeft"
              title="چرخش به چپ"
              ><v-icon small>mdi-rotate-left</v-icon></v-btn
            >
            <v-btn
              class="mx-1 btn-download rounded-pill"
              icon
              small
              @click="rotateRight"
              title="چرخش به راست"
              ><v-icon small>mdi-rotate-right</v-icon></v-btn
            >
            <v-btn
              class="mx-1 btn-download rounded-pill"
              icon
              small
              @click="flipX"
              title="قرینه افقی"
              ><v-icon small>mdi-flip-horizontal</v-icon></v-btn
            >
            <v-btn
              class="mx-1 btn-download rounded-pill"
              icon
              small
              @click="flipY"
              title="قرینه عمودی"
              ><v-icon small>mdi-flip-vertical</v-icon></v-btn
            >
          </div>

          <div
            style="height: 400px; width: 100%; background: #eee"
            :class="'shape-' + selectedShape"
          >
            <vue-cropper
              ref="cropper"
              :src="currentImageUrl"
              :view-mode="1"
              :auto-crop-area="1"
              style="width: 100%; height: 100%"
            ></vue-cropper>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="pa-3">
            <div class="text-subtitle-1 mb-4 font-weight-bold">
              تنظیمات خروجی
            </div>

            <v-select
              v-model="selectedShape"
              :items="shapeOptions"
              label="برش به شکل"
              dense
              outlined
              class="mb-2"
              @change="handleShapeChange"
            >
              <template v-slot:item="{ item }">
                <v-icon left>{{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:selection="{ item }">
                <v-icon left>{{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
            </v-select>

            <v-select
              v-model="exportSettings.format"
              :items="formatOptions"
              label="فرمت عکس"
              dense
              outlined
              :disabled="selectedShape !== 'rect'"
              :hint="
                selectedShape !== 'rect'
                  ? 'برای حفظ شفافیت، فرمت PNG انتخاب شده'
                  : ''
              "
              persistent-hint
            ></v-select>

            <v-slider
              v-if="exportSettings.format !== 'image/png'"
              v-model="exportSettings.quality"
              min="0.1"
              max="1.0"
              step="0.05"
              thumb-label
              label="کیفیت"
              hint="کیفیت کمتر = حجم کمتر"
              persistent-hint
              class="mt-2"
            ></v-slider>
            <v-divider class="my-4"></v-divider>
            <div class="text-caption mb-2">تغییر اندازه (اختیاری):</div>
            <v-row dense>
              <v-col cols="6"
                ><v-text-field
                  v-model="exportSettings.width"
                  label="عرض (px)"
                  type="number"
                  dense
                  outlined
                  hide-details
                ></v-text-field
              ></v-col>
              <v-col cols="6"
                ><v-text-field
                  v-model="exportSettings.height"
                  label="ارتفاع (px)"
                  type="number"
                  dense
                  outlined
                  hide-details
                ></v-text-field
              ></v-col>
            </v-row>
            <div class="text-caption mt-1 text-grey">
              اگر خالی بگذارید، سایز اصلی کراپ اعمال می‌شود.
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div class="d-flex w-100 pt-4 mt-2">
        <v-btn class="btn-delete rounded-lg" text @click="closeCropper"
          ><v-icon>mdi-close</v-icon>انصراف</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          class="btn-get-code rounded-lg mx-2"
          outlined
          @click="applyToAll"
          :loading="isApplyingToAll"
        >
          <v-icon>mdi-content-copy</v-icon>اعمال روی همه
        </v-btn>
        <v-btn class="btn-get-code rounded-lg" @click="saveCrop"
          ><v-icon>mdi-content-save</v-icon>اعمال و ذخیره</v-btn
        >
      </div>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "ImageEditorList",
  props: { value: { type: Array, default: () => [] } },
  data() {
    return {
      isApplyingToAll: false,
      cropperDialog: false,
      currentImageUrl: "",
      currentImageIndex: null,
      flipXState: 1,
      flipYState: 1,
      selectedShape: "rect",
      shapeOptions: [
        { text: "مستطیل", value: "rect", icon: "mdi-rectangle-outline" },
        { text: "دایره / بیضی", value: "circle", icon: "mdi-circle-outline" },
        { text: "لوزی", value: "rhombus", icon: "mdi-rhombus-outline" },
        { text: "مثلث", value: "triangle", icon: "mdi-triangle-outline" },
        { text: "پنج‌ضلعی", value: "pentagon", icon: "mdi-pentagon-outline" },
        { text: "شش‌ضلعی", value: "hexagon", icon: "mdi-hexagon-outline" },
        { text: "ستاره", value: "star", icon: "mdi-star-outline" },
      ],
      formatOptions: [
        { text: "JPEG", value: "image/jpeg" },
        { text: "PNG", value: "image/png" },
        { text: "WEBP", value: "image/webp" },
      ],
      exportSettings: {
        format: "image/jpeg",
        quality: 0.85,
        width: null,
        height: null,
      },
    };
  },
  computed: {
    images: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async applyToAll() {
      if (!this.$refs.cropper) return;
      this.isApplyingToAll = true;

      // دریافت تنظیمات دقیق کراپ از عکس فعلی
      const cropData = this.$refs.cropper.getData();

      const canvasOptions = {
        fillColor: this.selectedShape === "rect" ? "#ffffff" : "transparent",
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "high",
      };

      if (this.exportSettings.width)
        canvasOptions.width = parseInt(this.exportSettings.width);
      if (this.exportSettings.height)
        canvasOptions.height = parseInt(this.exportSettings.height);

      // پردازش تک‌تک عکس‌ها
      for (let i = 0; i < this.images.length; i++) {
        await this.processSingleImage(i, cropData, canvasOptions);
      }

      this.isApplyingToAll = false;
      this.closeCropper();
    },

    processSingleImage(index, cropData, canvasOptions) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = cropData.width;
          canvas.height = cropData.height;

          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate((cropData.rotate * Math.PI) / 180);
          ctx.scale(cropData.scaleX, cropData.scaleY);
          ctx.drawImage(
            img,
            -cropData.width / 2 - cropData.x,
            -cropData.height / 2 - cropData.y,
          );

          let finalCanvas = canvas;
          if (canvasOptions.width || canvasOptions.height) {
            finalCanvas = document.createElement("canvas");
            finalCanvas.width = canvasOptions.width || canvas.width;
            finalCanvas.height = canvasOptions.height || canvas.height;
            const finalCtx = finalCanvas.getContext("2d");
            if (canvasOptions.fillColor !== "transparent") {
              finalCtx.fillStyle = canvasOptions.fillColor;
              finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
            }
            finalCtx.drawImage(
              canvas,
              0,
              0,
              finalCanvas.width,
              finalCanvas.height,
            );
          }

          // اعمال ماسک شکل (دایره، ستاره و ...)
          if (this.selectedShape !== "rect") {
            finalCanvas = this.applyShapeMask(finalCanvas, this.selectedShape);
          }

          const dataUrl = finalCanvas.toDataURL(
            this.exportSettings.format,
            this.exportSettings.quality,
          );
          this.$set(this.images[index], "url", dataUrl);
          resolve();
        };
        img.src = this.images[index].url;
      });
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
    _drawPolygon(ctx, sides, w, h) {
      const centerX = w / 2,
        centerY = h / 2;
      const radius = Math.min(w, h) / 2;
      ctx.moveTo(centerX, centerY - radius);
      for (let i = 1; i <= sides; i++) {
        const angle = -Math.PI / 2 + (i * 2 * Math.PI) / sides;
        ctx.lineTo(
          centerX + radius * Math.cos(angle),
          centerY + radius * Math.sin(angle),
        );
      }
    },

    openCropper(index, url) {
      this.currentImageIndex = index;
      this.currentImageUrl = url;
      this.flipXState = 1;
      this.flipYState = 1;
      this.selectedShape = "rect";
      this.exportSettings.format = "image/jpeg";
      this.exportSettings.width = null;
      this.exportSettings.height = null;
      this.cropperDialog = true;
    },
    closeCropper() {
      this.cropperDialog = false;
    },
    handleShapeChange() {
      if (this.selectedShape !== "rect") {
        this.exportSettings.format = "image/png";
      }
    },
    saveCrop() {
      if (!this.$refs.cropper) return;

      const canvasOptions = {
        fillColor: this.selectedShape === "rect" ? "#ffffff" : "transparent",
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "high",
      };

      if (this.exportSettings.width)
        canvasOptions.width = parseInt(this.exportSettings.width);
      if (this.exportSettings.height)
        canvasOptions.height = parseInt(this.exportSettings.height);

      let canvas = this.$refs.cropper.getCroppedCanvas(canvasOptions);
      if (!canvas) return;

      if (this.selectedShape !== "rect") {
        canvas = this.applyShapeMask(canvas, this.selectedShape);
      }

      const croppedDataUrl = canvas.toDataURL(
        this.exportSettings.format,
        this.exportSettings.quality,
      );
      this.images[this.currentImageIndex].url = croppedDataUrl;
      this.closeCropper();
    },
    applyShapeMask(sourceCanvas, shape) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = sourceCanvas.width;
      canvas.height = sourceCanvas.height;
      const w = canvas.width,
        h = canvas.height;

      ctx.beginPath();
      switch (shape) {
        case "circle":
          ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, 2 * Math.PI);
          break;
        case "rhombus":
          ctx.moveTo(w / 2, 0);
          ctx.lineTo(w, h / 2);
          ctx.lineTo(w / 2, h);
          ctx.lineTo(0, h / 2);
          break;
        case "triangle":
          ctx.moveTo(w / 2, 0);
          ctx.lineTo(w, h);
          ctx.lineTo(0, h);
          break;
        case "pentagon":
          this._drawPolygon(ctx, 5, w, h);
          break;
        case "hexagon":
          this._drawPolygon(ctx, 6, w, h);
          break;
        case "star":
          this._drawStar(ctx, 5, w, h);
          break;
      }
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(sourceCanvas, 0, 0);
      return canvas;
    },

    _drawPolygon(ctx, sides, w, h) {
      const centerX = w / 2,
        centerY = h / 2;
      const radius = Math.min(w, h) / 2;
      ctx.moveTo(
        centerX + radius * Math.cos(0),
        centerY + radius * Math.sin(0),
      );
      for (let i = 1; i <= sides; i++) {
        const angle = (i * 2 * Math.PI) / sides;
        ctx.lineTo(
          centerX + radius * Math.cos(angle),
          centerY + radius * Math.sin(angle),
        );
      }
    },
    _drawStar(ctx, points, w, h) {
      const centerX = w / 2,
        centerY = h / 2;
      const outerRadius = Math.min(w, h) / 2;
      const innerRadius = outerRadius / 2.5;
      let angle = Math.PI / 2;
      let step = Math.PI / points;

      ctx.moveTo(centerX, centerY - outerRadius);
      for (let i = 0; i < 2 * points; i++) {
        const radius = i % 2 === 0 ? outerRadius : innerRadius;
        angle += step;
        ctx.lineTo(
          centerX + radius * Math.cos(angle),
          centerY - radius * Math.sin(angle),
        );
      }
    },

    rotateLeft() {
      if (this.$refs.cropper) this.$refs.cropper.rotate(-90);
    },
    rotateRight() {
      if (this.$refs.cropper) this.$refs.cropper.rotate(90);
    },
    flipX() {
      if (this.$refs.cropper) {
        this.flipXState *= -1;
        this.$refs.cropper.scaleX(this.flipXState);
      }
    },
    flipY() {
      if (this.$refs.cropper) {
        this.flipYState *= -1;
        this.$refs.cropper.scaleY(this.flipYState);
      }
    },
  },
};
</script>

<style>
.shape-circle .cropper-view-box,
.shape-circle .cropper-face {
  border-radius: 50%;
}

.shape-rhombus .cropper-view-box,
.shape-rhombus .cropper-face {
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
}

.shape-triangle .cropper-view-box,
.shape-triangle .cropper-face {
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
}

.shape-pentagon .cropper-view-box,
.shape-pentagon .cropper-face {
  clip-path: polygon(50% 0%, 100% 38%, 81% 100%, 19% 100%, 0% 38%);
}

.shape-hexagon .cropper-view-box,
.shape-hexagon .cropper-face {
  clip-path: polygon(
    50% 0%,
    93.3% 25%,
    93.3% 75%,
    50% 100%,
    6.7% 75%,
    6.7% 25%
  );
}

.shape-star .cropper-view-box,
.shape-star .cropper-face {
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
}
.hover-primary:hover .v-icon {
  color: var(--v-primary-base) !important;
}
</style>
